var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoVpcListMemory({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "auto",
    id: "4g0l0aye4a"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.529412 0 0 0 0 0.576471 0 0 0 0 0.639216 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#4g0l0aye4a)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#806FBD",
    strokeLinejoin: "round",
    d: "M7.65 16.203 20.35 8.869l2.667 4.619-12.702 7.333z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#806FBD",
    strokeLinejoin: "round",
    d: "M10.893 20.488 22.44 13.82l1.334 2.31-11.547 6.666z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#806FBD"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m10.959 16.601 1.154-.666.666 1.154-1.154.667zM13.268 15.268l1.155-.667.666 1.155-1.154.666zM15.577 13.935l1.154-.667.667 1.155-1.154.666zM17.887 12.601l1.154-.666.667 1.154-1.155.667z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoVpcListMemory);
export default __webpack_public_path__ + "static/media/ico-vpc-list-memory.5fd4d668306b9dbf8760fc3a296530ae.svg";
export { ForwardRef as ReactComponent };